export const initialState = {
  amount: 0,
  snacks: [],
}

function create(state, payload) {
  const newState = { ...state }

  newState.amount += 1
  newState.snacks = [...state.snacks, { ...payload, id: newState.amount }]

  return newState
}

function remove(state, { snackId }) {
  const newState = { ...state }

  newState.snacks = state.snacks.filter((snack) => snack.id !== snackId)
  newState.amount = newState.snacks.length

  return newState
}

// eslint-disable-next-line default-param-last
function reducer(state = initialState, { type, payload }) {
  switch (type) {
    case 'SNACK/CREATE':
      return create(state, payload)

    case 'SNACK/REMOVE':
      return remove(state, payload)

    case 'SNACK/REMOVE_ALL':
      return { ...initialState }

    default:
      return state
  }
}

export default reducer
